export default function Badge({ color, title }: { color: string; title: string }): JSX.Element {
  return (
    <div className={['inline-block', 'rounded-sm', 'bg-topaz', 'py-0.5', 'px-2', `bg-${color}`, 'N_10_R', 'text-white', 'mr-1'].join(' ')}>
      {title}
    </div>
  );
}
